<form [formGroup]="acodisWorkflowForm">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="name" class="control-label required">{{ 'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.workflow-name' | translate }}</label>
      <input id="name" maxlength="100" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="acodisWorkflowForm.controls.name"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.import-type' | translate}}</label>
      <ejs-dropdownlist [dataSource]="importTypes"
                        [fields]="enumDropdownSettings"
                        id="importType"
                        formControlName="importType">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="acodisWorkflowForm.controls.importType"></app-error-messages>
    </div>
  </div>
  <!-- Create fields for username and password -->
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="userName" class="control-label required">{{ 'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.userName' | translate }}</label>
      <input id="userName" maxlength="50" type="text" class="form-control" formControlName="userName" autocomplete="off"/>
      <app-error-messages [control]="acodisWorkflowForm.controls.userName"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="password" class="control-label required">{{ 'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.password' | translate }}</label>
      <input id="password" maxlength="50" type="password" class="form-control" formControlName="password" autocomplete="off"/>
      <app-error-messages [control]="acodisWorkflowForm.controls.password"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12 d-flex align-items-center">
      <button type="button"
              [disabled]="!acodisWorkflowForm.valid"
              (click)="testAcodisWorkflow()"
              class="btn btn-outline-secondary">
        {{'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.test-connection' | translate}}
      </button>
      <div class="ms-2">
        @if (isTestingConnection) {
          <div class="spinner-border spinner-border-sm me-3" role="status"></div>
        }
        @if (!isTestingConnection && testResult) {
          <div class="d-flex align-items-center">
            @if (testResult.succeeded) {
              <span class="text-success">{{'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.connection-success' | translate}}</span>
            }
            @if (!testResult.succeeded) {
              <span class="text-danger">{{'i18n.domain.import-configuration.acodis-workflows.workflow-form.form-fields.connection-failed' | translate}}</span><br>
              <span class="text-danger">{{testResult.logEntries[0]}}</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</form>
